import type { DashboardTaskItem } from "@models";
import type { ReactNode } from "react";
import { DashboardConnectedCard } from "./DashboardConnectedCard";
import { DashboardTaskRows } from "./DashboardTaskRows";

type DashboardOpenTasksCardProps = {
  tasks: DashboardTaskItem[];
  count?: number;
  actions?: ReactNode;
  selectedDeviceId?: string;
  fallbackDeviceId?: string;
  className?: string;
};

export const DashboardOpenTasksCard = ({
  tasks,
  count,
  actions,
  selectedDeviceId,
  fallbackDeviceId,
  className,
}: DashboardOpenTasksCardProps) => {
  return (
    <DashboardConnectedCard
      rootTestId="dashboard-open-tasks-connected-card"
      metricTestId="dashboard-digest-metric-card"
      caption="Open tasks"
      totalNumber={count ?? tasks.length}
      metricClassName="border-sky-200 bg-sky-50"
      valueClassName="text-sky-700"
      sectionLabel="Open tasks"
      actions={actions}
      className={className}
    >
      <div className="flex h-full min-h-0 flex-col gap-3">
        <DashboardTaskRows
          tasks={tasks}
          isLoading={false}
          emptyText="No open tasks match these filters."
          listTestId="dashboard-open-task-list"
          scrollTestId="dashboard-open-tasks-scroll"
          selectedDeviceId={selectedDeviceId}
          fallbackDeviceId={fallbackDeviceId}
        />
      </div>
    </DashboardConnectedCard>
  );
};
